import React from "react";
import { SvgIcon } from "@mui/material";
import { ReactComponent as LayoutSidebarSvg } from "./icons/LayoutSidebar.svg";
import { ReactComponent as SchoolSvg } from "./icons/School.svg";
import { ReactComponent as HomeSvg } from "./icons/Home.svg";
import { ReactComponent as AssignmentSvg } from "./icons/Assignment.svg";
import { ReactComponent as AccountCircleSvg } from "./icons/AccountCircle.svg";
import { ReactComponent as BooleanSvg } from "./icons/Boolean.svg";
import { ReactComponent as CalendarTodaySvg } from "./icons/CalendarToday.svg";
import { ReactComponent as CameraSvg } from "./icons/Camera.svg";
import { ReactComponent as PublishSvg } from "./icons/Publish.svg";
import { ReactComponent as EditSvg } from "./icons/Edit.svg";
import { ReactComponent as FolderOpenSvg } from "./icons/FolderOpen.svg";
import { ReactComponent as UseAISvg } from "./icons/UseAI.svg";
import { ReactComponent as TeacherSvg } from "./icons/Teacher.svg";
import { ReactComponent as StudentSvg } from "./icons/Student.svg";
import { ReactComponent as LabelSvg } from "./icons/Label.svg";
import { ReactComponent as VisibilitySvg } from "./icons/Visibility.svg";
import { ReactComponent as VisibilityOffSvg } from "./icons/VisibilityOff.svg";
import { ReactComponent as SwitchSvg } from "./icons/Switch.svg";
import { ReactComponent as TuneSvg } from "./icons/Tune.svg";
import { ReactComponent as StorageSvg } from "./icons/Storage.svg";
import { ReactComponent as CSVFileSvg } from "./icons/CSVFile.svg";
import { ReactComponent as KeySvg } from "./icons/Key.svg";
import { ReactComponent as BookSvg } from "./icons/Book.svg";
import { ReactComponent as SidebarSvg } from "./icons/Sidebar.svg";

const icons = {
  LayoutSidebar: LayoutSidebarSvg,
  School: SchoolSvg,
  Home: HomeSvg,
  Assignment: AssignmentSvg,
  AccountCircle: AccountCircleSvg,
  Boolean: BooleanSvg,
  CalendarToday: CalendarTodaySvg,
  Camera: CameraSvg,
  Publish: PublishSvg,
  FolderOpen: FolderOpenSvg,
  Edit: EditSvg,
  UseAI: UseAISvg,
  Teacher: TeacherSvg,
  Student: StudentSvg,
  Label: LabelSvg,
  Visibility: VisibilitySvg,
  VisibilityOff: VisibilityOffSvg,
  Switch: SwitchSvg,
  Tune: TuneSvg,
  Storage: StorageSvg,
  CSVFile: CSVFileSvg,
  Key: KeySvg,
  Book: BookSvg,
  Sidebar: SidebarSvg,
};

export default function FruitifyIcon({ name, ...props }) {
  const Component = icons[name];

  if (!Component) {
    throw `FruitifyIcon: No icon found for name "${name}"`;
  }

  return <SvgIcon component={Component} inheritViewBox {...props} />;
}
